import instance,{BASE_URL}from "../../services/api";
import toast from 'react-hot-toast';

const DocumentViewController =() =>{
  const getErrorMessage = (error) => {
  return (
    error.response?.data?.detail ||   // Django REST Framework style
    error.response?.data?.message ||  // custom backend message
    error.response?.data?.error ||    // another fallback
    error.message ||                  // Axios default
    "Something went wrong!"
  );
};

    const getEmployeeForGenrateDocument = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(
        `${BASE_URL}employees/generate-letters/`,
        {}
      );
      // console.log("Fetching attendance with params:", params);

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      // console.log("Fetched attendance data:", response.data);
      dispatch({ type: "GET_EMPLOYEE_FOR_DOCUMENTS_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
       const message = getErrorMessage(error);
      dispatch({
        type: "GET_EMPLOYEE_FOR_DOCUMENTS_FAILURE",
        payload: { error: error }
      });
      toast.error(message);
    }
  };
  
  const getInternshipLetter = (employeeId,first,last) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });

    try {
      const response = await instance.get(
        `${BASE_URL}internship-letter/${employeeId}/`,
        {
          responseType: "blob", // Important to handle PDF
        }
      );
      
      const fileURL = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = fileURL;
      link.setAttribute("download", `Internship_letter_${first}_${last}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      dispatch({
        type: "GET_INTERNSHIP_LETTER_SUCCESS",
        payload: "Payslip downloaded successfully",
      });
    } catch (error) {
      dispatch({ type: "GET_INTERNSHIP_LETTER_FAILURE", payload: false });
      console.error("Error generating payslip:", error);
      dispatch({ type: "ERROR", payload: "Failed to generate payslip" });
    }
  };
  
  return{
    getEmployeeForGenrateDocument, getInternshipLetter
  };

};

export default DocumentViewController;